import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = ["data-position"]
const _hoisted_3 = { class: "product-price-card__body" }
const _hoisted_4 = { class: "fa-ul" }
const _hoisted_5 = { class: "fa-li" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "fa-li" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "fa-li" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "fa-li" }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = { class: "fa-li" }
const _hoisted_14 = { class: "fa-li" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "d-none d-lg-block m-0 fs-small text-center" }
const _hoisted_17 = ["href", "innerHTML"]
const _hoisted_18 = ["href", "innerHTML"]

import Tooltip from '@/components/Tooltip.vue';
import { env, formatNumber } from '@/helpers';
import {
  PropType,
  ref,
  computed,
} from 'vue';
import Expand from '@/components/Expand.vue';
import PriceDetailsTable from '@/components/product/PriceDetailsTable.vue';
import { getRandomId } from '@/utils/BaseHelper';
import { Product } from '@/classes';
import BaseSpacer from '@/components/BaseSpacer.vue';
import BaseEqualizerElementPart from '@/components/BaseEqualizerElementPart.vue';
import BaseButton from '@/components/BaseButton.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'PriceCard',
  props: {
  product: {
    type: Object as PropType<Product>,
    required: true,
  },
  recommended: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  position: {
    type: Number,
  },
  isSingle: {
    type: Boolean,
    required: false,
    default: () => false,
  },
},
  emits: ['order', 'cart'],
  setup(__props, { emit: __emit }) {

library.add(faCheck);
library.add(faCircleInfo);

const emit = __emit;
const props = __props;

const productToUse = ref<Product>(props.product);
const cardKey = ref(getRandomId());

const emitCart = () => {
  emit('cart', productToUse.value);
};

const downloads = computed(() => {
  const rows: Record<'label' | 'href' | 'key', string>[] = [];

  if (productToUse.value.priceFileUrl) {
    rows.push({
      key: 'pricefile',
      label: 'Preisblatt',
      href: productToUse.value.priceFileUrl,
    });
  }

  const agbDocument = productToUse.value.getDocumentByKey('agb');
  if (productToUse.value.hasDocument('agb') && agbDocument) {
    rows.push({
      key: agbDocument.key,
      label: agbDocument.name || '',
      href: agbDocument.url || '#',
    });
  }

  const avbDocument = productToUse.value.getDocumentByKey('avb');
  if (productToUse.value.hasDocument('avb') && avbDocument) {
    rows.push({
      key: avbDocument.key,
      label: avbDocument.name || '',
      href: avbDocument.url || '#',
    });
  }

  return rows;
});

const bgbDocument = computed(() => (productToUse.value.hasDocument('bgb') ? productToUse.value.getDocumentByKey('bgb') : null));

const gasStorageSurchargeTotal = computed<string | null>(() => {
  if (props.product.branch === 'gas') {
    const gasStorageSurcharge = env('GAS_STORAGE_SURCHARGE', 0) as number; // cents
    const usage = props.product.price?.params.usage || 0;
    const total = (gasStorageSurcharge * usage) / 100;

    return formatNumber(total, 2);
  }

  return null;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["product-price-card-wrapper", { 'has-recommendation': productToUse.value.getRecommendationText(__props.isSingle) }])
  }, [
    _createVNode(BaseEqualizerElementPart, { name: "product-price-card-recommendation" }, {
      default: _withCtx(() => [
        (productToUse.value.getRecommendationText(__props.isSingle))
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "product-price-card-recommendation",
              innerHTML: productToUse.value.getRecommendationText(__props.isSingle)
            }, null, 8, _hoisted_1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("div", {
      class: _normalizeClass(["product-price-card", { recommended: __props.recommended }]),
      "data-position": __props.position
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(BaseEqualizerElementPart, {
          class: "product-price-card__title",
          name: "product-price-card-title",
          innerHTML: productToUse.value.name
        }, null, 8, ["innerHTML"]),
        _createVNode(BaseSpacer),
        _createVNode(BaseEqualizerElementPart, {
          class: "product-price-card__benefits",
          name: "product-price-card-benefits"
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_4, [
              _createElementVNode("li", null, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                ]),
                (productToUse.value.contractTermIsFixed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(" Mindest­vertrags­laufzeit bis zum ")
                    ], 64))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(productToUse.value.contractTermLabel) + " ", 1),
                (!productToUse.value.contractTermIsFixed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(" Mindest­vertrags­laufzeit ")
                    ], 64))
                  : _createCommentVNode("", true),
                (productToUse.value.contractTermMonths === '1')
                  ? (_openBlock(), _createBlock(Tooltip, { key: 2 }, {
                      title: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" Die Erstvertragslaufzeit beträgt 1 Monat ab Lieferbeginn. Nach Beendigung der Erstvertragslaufzeit wird Dein Tarif um jeweils einen Monat verlängert. ", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-solid fa-circle-info",
                          class: "text-primary"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (productToUse.value.contractTermMonths === '12')
                  ? (_openBlock(), _createBlock(Tooltip, { key: 3 }, {
                      title: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                        _createTextVNode(" Die Erstvertragslaufzeit beträgt 12 Monate ab Lieferbeginn. Nach Beendigung der Erstvertragslaufzeit wird Dein Tarif um jeweils einen Monat verlängert. ", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-solid fa-circle-info",
                          class: "text-primary"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (productToUse.value.contractTermMonths === '24')
                  ? (_openBlock(), _createBlock(Tooltip, { key: 4 }, {
                      title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                        _createTextVNode(" Die Erstvertragslaufzeit beträgt 24 Monate ab Lieferbeginn. Nach Beendigung der Erstvertragslaufzeit wird Dein Tarif um jeweils einen Monat verlängert. ", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-solid fa-circle-info",
                          class: "text-primary"
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              (productToUse.value.isSpotMarketPrices && productToUse.value.hasPriceGuarantee)
                ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                    ]),
                    _cache[4] || (_cache[4] = _createTextVNode(" Spotmarktpreise ", -1)),
                    _createVNode(Tooltip, null, {
                      title: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                        _createElementVNode("b", null, "Festpreis im ersten Monat", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" Im ersten Monat erhältst Du den hier genannten Arbeits- und Grundpreis. ", -1),
                        _createElementVNode("br", null, null, -1),
                        _createElementVNode("br", null, null, -1),
                        _createElementVNode("b", null, "Dynamischer Tarif ab dem zweiten Monat", -1),
                        _createElementVNode("br", null, null, -1),
                        _createTextVNode(" Anstelle eines festen Arbeitspreises pro Kilowattstunde und eines festen Grundpreises orientiert sich der dynamische Tarif an viertelstündlichen Börsenpreisen. ", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-solid fa-circle-info",
                          class: "text-primary"
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (productToUse.value.hasPriceGuarantee && !productToUse.value.isSpotMarketPrices)
                ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
                    _createElementVNode("span", _hoisted_9, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                    ]),
                    (productToUse.value.priceGuaranteeIsFixed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" Preisgarantie bis zum ")
                        ], 64))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(productToUse.value.priceGuaranteeLabel) + " ", 1),
                    (!productToUse.value.priceGuaranteeIsFixed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Preisgarantie ")
                        ], 64))
                      : _createCommentVNode("", true),
                    (productToUse.value.priceGuaranteeTermMoths === '12')
                      ? (_openBlock(), _createBlock(Tooltip, { key: 2 }, {
                          title: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" Unser Tarif bietet Dir eine Preisgarantie von 12 Monaten. Sie schützt Dich vor Preiserhöhungen im ausgewählten Zeitraum. Die Preisgarantie wird auf den reinen Energiepreis sowie die Netznutzungsentgelte gewährt und gilt ab Lieferbeginn. ", -1)
                          ]))]),
                          default: _withCtx(() => [
                            _createVNode(_unref(FontAwesomeIcon), {
                              icon: "fa-solid fa-circle-info",
                              class: "text-primary"
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (productToUse.value.priceGuaranteeTermMoths === '24')
                      ? (_openBlock(), _createBlock(Tooltip, { key: 3 }, {
                          title: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                            _createTextVNode(" Unser Tarif bietet Dir eine Preisgarantie von 24 Monaten. Sie schützt Dich vor Preiserhöhungen im ausgewählten Zeitraum. Die Preisgarantie wird auf den reinen Energiepreis sowie die Netznutzungsentgelte gewährt und gilt ab Lieferbeginn. ", -1)
                          ]))]),
                          default: _withCtx(() => [
                            _createVNode(_unref(FontAwesomeIcon), {
                              icon: "fa-solid fa-circle-info",
                              class: "text-primary"
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (!productToUse.value.isEco && (productToUse.value.category.key === 'power' || productToUse.value.category.key=== 'heatingPower'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                    ]),
                    _cache[7] || (_cache[7] = _createTextVNode(" Ohne Ökostrom ", -1))
                  ]))
                : _createCommentVNode("", true),
              (productToUse.value.isEco && (productToUse.value.category.key === 'power' || productToUse.value.category.key=== 'heatingPower'))
                ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                    ]),
                    _cache[9] || (_cache[9] = _createTextVNode(" 100 % Ökostrom ", -1)),
                    _createVNode(Tooltip, null, {
                      title: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createTextVNode(" Unser Ökostrom wird zu 100 % aus Wasserkraft gewonnen. ", -1)
                      ]))]),
                      default: _withCtx(() => [
                        _createVNode(_unref(FontAwesomeIcon), {
                          icon: "fa-solid fa-circle-info",
                          class: "text-primary"
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productToUse.value.benefits, (benefit, binx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `${productToUse.value.id}-benefit-${binx}`
                }, [
                  _createElementVNode("span", _hoisted_14, [
                    _createVNode(_unref(FontAwesomeIcon), { icon: "fa-regular fa-check" })
                  ]),
                  _createElementVNode("span", { innerHTML: benefit }, null, 8, _hoisted_15)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }),
        _createVNode(BaseSpacer),
        _cache[17] || (_cache[17] = _createElementVNode("hr", { class: "m-0" }, null, -1)),
        _createVNode(BaseSpacer),
        (_openBlock(), _createElementBlock("div", {
          class: "product-price-card__monthly text-center",
          key: `monthly-${cardKey.value}`
        }, [
          _createTextVNode(_toDisplayString(productToUse.value.getPriceFormatted('monthly')) + " € ", 1),
          _createElementVNode("span", null, [
            _cache[11] || (_cache[11] = _createTextVNode(" Abschlag pro Monat ", -1)),
            _createVNode(Tooltip, null, {
              title: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" Du kannst Deinen monatlichen Abschlag nachträglich im Online-Servicecenter oder über unsere Hotline ", -1),
                _createElementVNode("a", {
                  href: "tel:+498001332331",
                  target: "_blank"
                }, "0800 133 233 1", -1),
                _createTextVNode(" (Mo.-Fr. 07-19 Uhr, Sa. 08-16 Uhr, kostenlos) anpassen. ", -1)
              ]))]),
              default: _withCtx(() => [
                _createVNode(_unref(FontAwesomeIcon), {
                  icon: "fa-solid fa-circle-info",
                  class: "text-primary"
                })
              ]),
              _: 1
            })
          ])
        ])),
        _createVNode(BaseSpacer, { size: "r" }),
        (_openBlock(), _createElementBlock("div", {
          class: "product-price-card__yearly text-center",
          key: `monthly-${cardKey.value}`
        }, [
          _createTextVNode(_toDisplayString(productToUse.value.getPriceFormatted('yearly')) + " € ", 1),
          _cache[12] || (_cache[12] = _createElementVNode("span", null, " Energiepreis pro Jahr ", -1))
        ])),
        (gasStorageSurchargeTotal.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(BaseSpacer),
              _createElementVNode("p", _hoisted_16, [
                _createElementVNode("b", null, [
                  _cache[13] || (_cache[13] = _createTextVNode("Alle Preise exkl. aktueller Gasspeicherumlage", -1)),
                  _cache[14] || (_cache[14] = _createElementVNode("br", null, null, -1)),
                  _createTextVNode("i. H. v. " + _toDisplayString(gasStorageSurchargeTotal.value) + " € pro Jahr.", 1)
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        _createVNode(BaseSpacer),
        _createVNode(BaseEqualizerElementPart, { name: "product-price-card-downloads" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("ul", {
              class: "product-price-card__downloads text-center",
              key: `downloads-${cardKey.value}`
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(downloads.value, (download, inx) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `product-${productToUse.value.id}-download-${inx}`
                }, [
                  _createElementVNode("a", {
                    href: download.href,
                    target: "_blank",
                    innerHTML: download.label
                  }, null, 8, _hoisted_17)
                ]))
              }), 128))
            ]))
          ]),
          _: 1
        }),
        _createVNode(BaseEqualizerElementPart, { name: "product-price-card-bgb" }, {
          default: _withCtx(() => [
            (bgbDocument.value)
              ? (_openBlock(), _createElementBlock("ul", {
                  class: "product-price-card__downloads text-center",
                  key: `bgb-${cardKey.value}`
                }, [
                  _createElementVNode("li", null, [
                    _createElementVNode("a", {
                      href: bgbDocument.value.url || '#',
                      target: "_blank",
                      innerHTML: bgbDocument.value.name
                    }, null, 8, _hoisted_18)
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(BaseSpacer),
        _createVNode(Expand, {
          "font-size": "small",
          "button-class": "justify-content-center justify-content-lg-start"
        }, {
          title: _withCtx(() => [...(_cache[15] || (_cache[15] = [
            _createTextVNode("Preisdetails zum Sonderkundenvertrag", -1)
          ]))]),
          default: _withCtx(() => [
            (_openBlock(), _createBlock(PriceDetailsTable, {
              product: productToUse.value,
              key: `details-${cardKey.value}`
            }, null, 8, ["product"]))
          ]),
          _: 1
        }),
        _createVNode(BaseSpacer),
        _createVNode(BaseButton, {
          "text-align": "center",
          width: "full",
          "link-type": "button",
          onClick: emitCart
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
            _createTextVNode(" Tarif auswählen ", -1)
          ]))]),
          _: 1
        })
      ])
    ], 10, _hoisted_2)
  ], 2))
}
}

})